
export default {
    name: 'taux-chambres',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {

    }
}